






























import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import { WexDebitCardManageCardViewState } from "@/shared/types";

@Component({
  components: {
  }
})
export default class WexDebitCardManageCardForm extends Vue {
  wexDebitCardsStore = useWexDebitCardsStore();

  WexDebitCardManageCardViewState = WexDebitCardManageCardViewState;
  selected = null;

  get options () {
    return [
      { value: "deactivated", text: "Deactivate this card and order a new one." },
      { value: "changePin", text: "Change/Update PIN number" }
    ];
  }

  get submitDisabled () {
    return this.selected === null;
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();

    this.wexDebitCardsStore.setWexDebitCardManageCardViewState(this.selected);
  }
}
